import { useIntl } from 'react-intl';
import { useQuery } from 'react-query';

import ActorService from '@/api/Actor/ActorService';

export const GET_STORE_BY_ID = 'GET_STORE_BY_ID';

export const useGetStoreById = ({
  sellerId,
  storeId,
}: {
  sellerId?: string;
  storeId?: string;
}) => {
  const intl = useIntl();

  const { data: store, isLoading } = useQuery(
    [GET_STORE_BY_ID, { sellerId, storeId, locale: intl.locale }],
    async () => {
      if (!sellerId || !storeId) {
        return undefined;
      }

      const response = await ActorService.getStoreByIdQuery({
        sellerId,
        storeId,
      });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {
      staleTime: Infinity,
    },
  );

  return { store, isLoading };
};
